import { Button } from '../../../../Button';
import { FormControlSizes } from '../../../../Form/types';
import { IconName } from '../../../../Icons/IconNames';
import { Tooltip } from '../../../../Tooltip';
import type { EntityAdminRecord } from '../../../types';
import type { DrawerOptionCreateAction } from '../types';

export function DrawerOptionCreateActionButton<TForm extends EntityAdminRecord>({
  createAction,
  field,
  form,
  isFieldDisabled,
}: {
  createAction: DrawerOptionCreateAction<TForm>;
  field: string;
  form: TForm;
  isFieldDisabled: boolean;
}) {
  const disabled = isFieldDisabled || createAction.getIsDisabled?.(form) === true;
  return (
    <Tooltip tooltip={disabled ? createAction.getDisabledTooltip?.(form) : undefined}>
      <Button
        ghost
        size={FormControlSizes.Tiny}
        startIcon={IconName.Plus}
        disabled={disabled}
        onClick={() => createAction.onClick(form)}
        data-testid={`entity-admin-drawer-${field}-create-button`}
      >
        {createAction.label ?? 'New'}
      </Button>
    </Tooltip>
  );
}
